import clsx from "clsx";
import type React from "react";
import { useLocation } from "react-router";
import { useAuth } from "../../../../app/modules/auth";
import { checkIsActive, KTIcon, type WithChildren } from "../../../helpers";

type Props = {
	to: string;
	title: string;
	icon?: string;
	fontIcon?: string;
	hasBullet?: boolean;
	userRoles?: number[];
	exact?: boolean;
};

const AsideMenuItemWithSub: React.FC<Props & WithChildren> = ({
	children,
	to,
	title,
	icon,
	fontIcon,
	hasBullet,
	userRoles,
	exact = false,
}) => {
	const { pathname } = useLocation();
	const { currentUser } = useAuth();
	const isActive = checkIsActive(pathname, to, exact);

	// If userRoles is defined and currentUser's role_id is not in userRoles, hide the menu item
	if (
		userRoles &&
		currentUser?.role_id &&
		!userRoles.includes(currentUser.role_id)
	) {
		return null;
	}

	return (
		<div
			className={clsx("menu-item", { "here show": isActive }, "menu-accordion")}
			data-kt-menu-trigger="click"
		>
			<span className="menu-link">
				{hasBullet && (
					<span className="menu-bullet">
						<span className="bullet bullet-dot"></span>
					</span>
				)}
				{icon && (
					<span className="menu-icon">
						<KTIcon iconName={icon} className="fs-2" />
					</span>
				)}
				{fontIcon && <i className={clsx("bi fs-3", fontIcon)}></i>}
				<span className="menu-title">{title}</span>
				<span className="menu-arrow"></span>
			</span>
			<div
				className={clsx("menu-sub menu-sub-accordion", {
					"menu-active-bg": isActive,
				})}
			>
				{children}
			</div>
		</div>
	);
};

export { AsideMenuItemWithSub };
